import { AxiosInstance } from "axios";

import {
  PostSwornDeclarationRequestService,
  PostSwornDeclarationResponseService,
} from "./legal.type";

export default class LegalServices {
  private axios: AxiosInstance;
  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }
  public async saveDeclaration(
    id: string,
    declaration: any,
  ): Promise<PostSwornDeclarationResponseService> {
    const url: string = `/declaration/${id}`;
    return this.axios.post(url, declaration);
  }
  public async updateDeclaration(
    id: string,
    declaration: any,
  ): Promise<PostSwornDeclarationResponseService> {
    const url: string = `/declaration/update/${id}`;
    return this.axios.patch(url, declaration);
  }
}
